module.exports = __webpack_public_path__ + "static/logo2-ecad7807d3661ee2a941f597ee6e81e1.png";